/* ═══════════════════════════════════════════════════════════════
   HIGHMARK COLLECTIVE — THEME JAVASCRIPT
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  // ── Accordion toggles (PDP) ────────────────────────────────────
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.nextElementSibling;
      if (!target) return;
      var isOpen = target.classList.toggle('is-open');
      var icon = btn.querySelector('[data-accordion-icon]');
      if (icon) icon.textContent = isOpen ? '−' : '+';
    });
  });

  // ── PDP gallery thumb selection ────────────────────────────────
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var mainImg = document.querySelector('[data-gallery-main]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var src = thumb.getAttribute('data-img');
      if (mainImg && src) {
        mainImg.style.backgroundImage = 'url(' + src + ')';
      }
    });
  });

  // ── Variant swatch selection ───────────────────────────────────
  var variantGroups = document.querySelectorAll('[data-variant-group]');
  variantGroups.forEach(function (group) {
    var swatches = group.querySelectorAll('[data-variant-swatch]');
    var labelOut = group.querySelector('[data-variant-label]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        if (labelOut) labelOut.textContent = sw.getAttribute('data-variant-name') || '';
      });
    });
  });

  // ── Quantity stepper ───────────────────────────────────────────
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-qty-input]');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  // ── Article TOC active state on scroll ─────────────────────────
  var tocLinks = document.querySelectorAll('[data-toc-link]');
  if (tocLinks.length) {
    var headings = [];
    tocLinks.forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      var heading = document.getElementById(id);
      if (heading) headings.push({ link: link, heading: heading });
    });
    var setActive = function () {
      var scrolled = window.scrollY + 120;
      var current = null;
      headings.forEach(function (h) {
        if (h.heading.offsetTop <= scrolled) current = h;
      });
      tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
      if (current) current.link.classList.add('is-active');
    };
    window.addEventListener('scroll', setActive);
    setActive();
  }

  // ── Mobile menu toggle ─────────────────────────────────────────
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // ── Bundle option selection ────────────────────────────────────
  document.querySelectorAll('[data-bundle-group]').forEach(function (group) {
    var options = group.querySelectorAll('[data-bundle-option]');
    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT') return;
        options.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
      });
    });
  });

})();
